import { useState } from 'react';
import type { ChangeEvent } from 'react';

export const useSelection = (rows): [
  string[],
  (event: ChangeEvent<HTMLInputElement>, rowId: string) => void,
  () => void,
  (event: ChangeEvent<HTMLInputElement>) => void,
  (rows: string[]) => void,
] => {
  const [selectedRows, setSelectedRows] = useState<string[] | []>([]);

  const handleSelect = (event: ChangeEvent<HTMLInputElement>, rowId: string): void => {
    setSelectedRows((prevSelectedRows) => {
      if (event.target.checked) {
        return [...prevSelectedRows, rowId];
      }

      return prevSelectedRows.filter((selectedRow) => selectedRow !== rowId);
    });
  };

  const handleClearSelected = (): void => {
    setSelectedRows([]);
  };

  const handleSelectAll = (event: ChangeEvent<HTMLInputElement>): void => {
    if (event.target.checked) {
      setSelectedRows(rows.map((row) => row.id));
      return;
    }

    handleClearSelected();
  };

  // function to update the selected rows state
  const updateSelectedRows = (allRows: string[]) => {
    setSelectedRows(allRows);
  };

  return [selectedRows, handleSelect, handleClearSelected, handleSelectAll, updateSelectedRows];
};
